import { TYPES } from "./media.type";

const initState = {
  medias: null,
  meta: null,
  resize: null,
  video: null,
  month: null,
  media: null,
};

const mediaReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.GET_MEDIA_SUCCESS:
      return {
        ...state,
        medias: payload,
      };
    case TYPES.GET_MEDIA_METADATA_SUCCESS:
      return {
        ...state,
        meta: payload,
      };
    case TYPES.GET_RESIZE_METADATA_SUCCESS:
      return {
        ...state,
        resize: payload,
      };
    case TYPES.GET_VIDEO_SUCCESS:
      return {
        ...state,
        video: payload,
      };
    case TYPES.SET_MONTH_SUCCESS:
      return {
        ...state,
        month: payload,
      };
    //media
    case TYPES.GET_MEDIA_BY_BRANCH_BY_DATE_SUCCESS:
      return {
        ...state,
        media: payload,
      };

    default:
      return state;
  }
};

export default mediaReducer;
